import { RefObject, useEffect } from 'react';

export const useClickOutside = (
  ref: RefObject<HTMLElement> | null,
  cb: (e?: Event) => void,
  deps?: unknown,
) => {
  useEffect(() => {
    const listener = (event: Event) => {
      if (!ref || ref.current?.contains(event.target as Node)) {
        return;
      }

      cb(event);
      event.stopPropagation();
    };

    document.addEventListener('mousedown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, deps]);
};
